<template>
  <div class="specification">
    <van-empty
      v-if="isErrorPage"
      description="暂无商品数据"
      image="https://static.91jkys.com/attachment/20210428105356694_a8c6c937d65640aaae9cf82b8c4af801.png"
    ></van-empty>
    <div v-if="message && !isErrorPage" class="box" @scroll="handleScroll">
      <div class="img">
        <swiper-imgs
          class="img-fit-contain"
          :imgList="imageList"
          :item="message"
          @onChange="onChange"
          @clickSwipe="showPreview"
          :current.sync="current"
        ></swiper-imgs>
      </div>

      <div class="main-info">
        <span class="price" v-if="!isSellOut || message.realPrice">{{ message.realPrice | price }}</span>
        <span class="price isSellOut" v-else>—</span>
        <span class="name">
          <div
            v-if="message.attribute == 1 || message.attribute == 0"
            style="display: inline-block; vertical-align: middle; height: 16px; width: 32px"
          >
            <span class="tag-rx" v-if="message.attribute == 1">处方药</span>
            <span class="tag-otc" v-if="message.attribute == 0">OTC</span>
          </div>

          <span class="goods-name" style="line-height: 20px">
            {{ message.name || message.drugName }} {{ message.spec }}
          </span>
        </span>
        <!-- 领取优惠券 -->
        <div class="coupon-wrap">
          <coupon-bar :itemId="itemId" />
        </div>
        <div class="separator" />

        <div class="brand-publicity">
          <span class="icon-box" v-for="(item, index) in tipList" :key="index">
            <van-image :src="item.img + addOssParams(16, 16)" height="16" width="16" style="margin-right: 4px" round />
            {{ item.title }}
          </span>
        </div>
        <!-- <img class="labels" :src="require('../../assets/imgs/brand.png')" /> -->
      </div>
      <div class="indication" v-if="isDrug == 1 && message.isRx !== RxTypeNum.CHUFANGYA0">
        <h2 class="title">适应症</h2>
        <span class="text">
          {{ message.indication }}
        </span>
      </div>
      <div class="data-table">
        <div class="line">
          <span class="label">规格</span>
          <span class="value">{{ message.spec }}</span>
        </div>
        <div class="separator" />
        <div class="line">
          <span class="label">生产厂家</span>
          <span class="value">{{ message.enterprise }}</span>
        </div>
      </div>
      <template>
        <van-tabs sticky swipeable class="tabs" v-model="activeTab" v-if="message.isRx !== RxTypeNum.CHUFANGYA0">
          <van-tab class="self-tab" :title="isDrug == 1 ? '药品介绍' : '商品介绍'">
            <section class="tab-container no-padding">
              <img class="img-intro" v-for="(img, index) in infoImgs" :src="img" :key="index" />
            </section>
          </van-tab>

          <van-tab class="self-tab" title="说明书">
            <section class="tab-container">
              <tip content="此药品说明书不能替代纸质说明书，如遇到此药品说明书与纸质说明书不符，以纸质说明书为准"></tip>
              <ul class="explain">
                <li v-for="item in isDrug == 1 ? descList : noDrugInfoList" :key="item.key">
                  <h4 class="_title">【{{ item.name }}】</h4>
                  <p class="desc">{{ item.value | extfilter }}</p>
                </li>
              </ul>
            </section>
          </van-tab>
        </van-tabs>
        <section class="tab-container no-padding" v-else>
          <img class="img-intro" :src="infoImgs[infoImgs.length - 1]" :key="index" />
        </section>
      </template>

      <div class="bottom" :class="{ 'short-bottom': isHideBottom }"></div>
      <div class="fixed" v-if="!isHideBottom">
        <div v-if="isGetOff || isSellOut" class="error-tip">商品已经{{ isGetOff ? '下架' : '售罄' }}啦～</div>
        <div class="flex space-between align-center fix-content pl16 pr16">
          <div
            class="left flex center column"
            @click="$router.push({ name: 'requestCart' }).catch((err) => err)"
            v-track-event.click="{ trackId: 'zyyd-click-Goods-NavigationBar-Cart', custom: { itemId } }"
          >
            <IconFont style="font-size: 20px; margin-bottom: 7px" icon-name="gouwuche" class="icon-shopcart" />

            <span>需求清单</span>
          </div>
          <div class="right nowrap" v-if="showBottomBtn">
            <van-button
              round
              plain
              type="primary"
              size="mini"
              class="submit_button"
              v-reClick="() => showSkuPopup('cart')"
              :disabled="isGetOff || isSellOut"
              v-track-event.click="{ trackId: 'zyyd-click-Goods-NavigationBar-Add2Cart', custom: { itemId } }"
            >
              加入需求清单
            </van-button>
            <van-button
              round
              type="primary"
              size="mini"
              class="submit_button button1"
              :disabled="isGetOff || isSellOut"
              v-reClick="() => showSkuPopup('buy')"
              v-track-event.click="{ trackId: 'zyyd-click-Goods-NavigationBar-Buy', custom: { itemId } }"
            >
              {{ isDrug == 1 ? '找医生开药' : message.rxOrCheck == 2 ? '找医生确认' : '立即购买' }}
            </van-button>
          </div>
        </div>
      </div>
      <div
        style="position: fixed; right: 14px"
        v-if="!isHiddenTop"
        :style="'bottom:' + (isHideBottom ? 52 : 108) + 'px'"
        @click="handleClickBottom"
      >
        <img src="./img/back.png" style="width: 44px; height: 44px" alt="" />
      </div>
    </div>
    <van-popup
      v-model="popupVisible"
      round
      position="bottom"
      :close-on-click-overlay="true"
      :close-on-popstate="true"
      :overlay-style="{ zIndex: 2001 }"
    >
      <SkuPopup
        :visible.sync="popupVisible"
        ref="skuPopup"
        :type="popupType"
        :loading="isLoading"
        :goodsDetail="message"
        @addCart="addRequest"
        @submit="submit"
      />
    </van-popup>
    <van-popup
      v-model="diseasePopupVisible"
      round
      position="bottom"
      :close-on-click-overlay="true"
      :close-on-popstate="true"
      :overlay-style="{ zIndex: 2002 }"
    >
      <DiseasePopup @close="handleDiseaseClose" @cross="handleDiseaseCross" @confirm="handleDiseaseConfirm" />
    </van-popup>
  </div>
</template>
<script>
import { ResourceCodeEnum } from '@/constant';

import SwiperImgs from './components/SwiperImgs.vue';
import SkuPopup from './components/SkuPopup';
import Vue from 'vue';
import { ImagePreview } from '@zyf2e/capui-mobile';
import Tip from './components/tip.vue';
import jumpCenter from '@/mixins/jumpCenter';
import couponBar from '../coupon/components/couponBar.vue';
import IconFont from '@/components/iconFont.vue';
import DiseasePopup from './components/DiseasePopup';

Vue.use(ImagePreview);

export default {
  components: {
    SwiperImgs,
    SkuPopup,
    Tip,
    couponBar,
    IconFont,
    DiseasePopup
  },
  mixins: [jumpCenter],
  data() {
    return {
      message: null,
      mainNum: null,
      stockNum: null,
      cacheStock: {
        stockNum: 0, // 真实库存数量
        stock: 0 // 减去购物车库存数量  加入购物车专用
      },
      targetEl: null,
      amount: null,
      otherNum: null,
      load: false,
      isErrorPage: false,
      isHideBottom: false,
      popupVisible: false,
      popupType: '', // cart buy
      isDrug: 1, // 0 非药品 1 药品
      isLoading: false,
      isHiddenTop: true,
      noDrugInfoList: [
        { name: '商品名称', key: 'name' },
        { name: '单位', key: 'unit' },
        { name: '规格', key: 'spec' },
        { name: '生产厂家', key: 'enterprise' }
      ],
      infoList: [
        { name: '通用名称', key: 'name' },
        { name: '单位', key: 'unit' },
        { name: '规格', key: 'spec' },
        { name: '生产厂家', key: 'enterprise' },
        { name: '适应症', key: 'indication' },
        { name: '用法用量', key: 'usageDosageDescription' }
      ],
      descList: [
        { name: '成份', key: 'ingredient' },
        { name: '性状', key: 'description' },
        { name: '适应症', key: 'indication' },
        { name: '单位', key: 'unit' },
        { name: '规格', key: 'spec' },
        { name: '用法用量', key: 'usageDosageDescription' },
        { name: '剂型', key: 'reagentType' },
        { name: '不良反应', key: 'untowardEffect' },
        { name: '禁忌', key: 'contraindication' },
        { name: '注意事项', key: 'attention' },
        { name: '药物相互作用', key: 'drugInteractions' },
        { name: '药物毒性', key: 'pharmacologicalToxicity' }
      ],
      current: 0,
      activeTab: 0,
      itemId: '',
      startTime: '',
      RxTypeNum: {
        CHUFANGYA0: 1,
        OTC: 2
      },
      tipList: [],
      diseasePopupVisible: false,
      tempAmount: 0
    };
  },
  filters: {
    extfilter(v) {
      if (!v) return '完善中';
      return v;
    }
  },
  created() {
    this.startTime = new Date().getTime();
    this.isHideBottom = this.$route.query.from === 'preOrder';
    this.getTipList();
  },
  destroyed() {
    const endTime = new Date().getTime();
    const duration = endTime - this.startTime;
    // eslint-disable-next-line no-undef
    Telescope.trackPage({ trackId: 'zyyd-click-Goods', custom: { itemId: this.itemId, duration } });
  },
  mounted() {
    // setTitle('药品说明书');
    this._getData();
  },
  computed: {
    imageList() {
      return this.message && (this.message.itemUrlList || []).map((el) => window.util.httpsReplace(el));
    },
    infoImgs() {
      return this.message && (this.message.infoImgs || '').split(';').map((el) => window.util.httpsReplace(el));
    },
    isSellOut() {
      // status 0 : 上架， 1: 下架
      return this.message && this.message.status === 0 && this.message.stockNum === 0;
    },
    isGetOff() {
      return this.message && this.message.status === 1;
    },
    showBottomBtn() {
      return this.message && this.message.drugTypeClassification != 1;
    }
  },

  methods: {
    handleScroll(el) {
      this.targetEl = el.target;
      if (this.targetEl.scrollTop > 800) {
        this.isHiddenTop = false;
      } else {
        this.isHiddenTop = true;
      }
    },
    handleClickBottom() {
      this.targetEl.scrollTop = 0;
    },
    showSkuPopup(type) {
      if (type !== 'buy' && this.cacheStock.stock === 0) {
        this.$toast('您加入需求清单的数量已达上限，无法继续添加');
        return;
      }
      this.popupVisible = true;
      if (this.popupType !== type) {
        if (this.$refs.skuPopup) this.$refs.skuPopup.resetNum();

        if (type === 'buy') {
          this.$set(this.message, 'stockNum', this.cacheStock.stockNum);
        } else {
          // 如果是加入购物车 用减去购物车的库存

          this.$set(this.message, 'stockNum', this.cacheStock.stock);
        }
      }

      this.popupType = type;
    },
    async getItemMun(itemId) {
      const { stockNum, amount, stock } = await this.$fetch.getItemMun({ itemId });

      this.amount = amount ? amount : '';

      this.stockNum = stockNum;
    },
    // 删除购物车
    deleteTrolley() {
      if (this.amount === '') return;
      const { itemId } = this.$route.query;
      this.$dialog
        .confirm({
          title: '确认将此药品移出商品清单？',
          confirmButtonText: '再想想',
          cancelButtonText: '删除'
        })
        .then(() => {})
        .catch(() => {
          this.$fetch.deleteTrolley({ itemId }).then(() => {
            this.amount = '';
          });
        });
    },
    addTrolley(amount) {
      const { itemId } = this.$route.query;
      this.$fetch.addTrolley({ itemId, amount }).then(({ stockNum, canAdd, message }) => {
        if (!canAdd) {
          this.stockNum = stockNum;
          this.$toast(message);
          return;
        }
        if (amount > this.amount) {
          this.$toast('已加入需求清单');
        }
        this.$set(this, 'amount', amount);
        this.$set(this, 'stockNum', stockNum);
      });
    },
    minus() {
      const amount = Number(this.$refs.stepper.currentValue) - 1;
      if (amount < 1) {
        this.deleteTrolley();
        return;
      }
      this.addTrolley(amount);
    },
    plus() {
      const amount = Number(this.$refs.stepper.currentValue) + 1;
      this.addTrolley(amount);
    },
    handleBlur() {
      const amount = Number(this.$refs.stepper.currentValue);
      this.addTrolley(amount);
    },
    // change(v) {
    //   if (Number(v) < 1) {
    //     this.deleteTrolley();
    //     return;
    //   }
    //   this.addTrolley(Number(v));
    // },
    addRequest(amount) {
      const { itemId, isDrug } = this.$route.query;
      this.$fetch.addOneTrolley({ itemId, amount, isDrug }).then(({ stockNum, canAdd, message = '' }) => {
        if (!canAdd) {
          this.$set(this, 'stockNum', stockNum);
          this.$toast(message);
          this.popupVisible = false;
          return;
        }
        this.popupVisible = false;
        this.$set(this, 'stockNum', stockNum);

        this.amount = amount;
        window.localStorage.setItem('recentAddType', isDrug);

        this.$toast('已加入需求清单');
      });
    },
    async skuPopupSubmit(amount) {
      if (this.isDrug == 1) {
        this.popupVisible = false;
        this.diseasePopupVisible = true;
        this.tempAmount = amount;
      } else {
        this.submit(amount);
      }
    },
    async submit(amount, diseaseDesc) {
      if (this.load) return;
      this.load = true;
      const { itemId, isDrug } = this.$route.query;
      await this.$fetch
        .submitTrolley({
          type: 'immediateApply',
          isDrug,
          detail: [
            {
              itemId,
              amount,
              isDrug
            }
          ],
          diseaseDesc
        })
        .then((res) => {
          const { status, requirementId } = res;
          if (status === 1) {
            window.wx.closeWindow();
            return;
          }
          if (status === 3) {
            // const params = {
            //   orders: [
            //     {
            //       itemId,
            //       itemNum: amount,
            //       deliveryWay: 1
            //     }
            //   ],
            //   channel: 'MEDIC_SALE'
            // };
            this.saveDataAndToPreOrder({
              settlementId: requirementId,
              isDrug,
              bizType: 'need',
              bizId: requirementId
            });
            // this.requestPreOrderAndJumpToPlaceOrder(
            //   {
            //     orders: [
            //       {
            //         itemId,
            //         itemNum: amount,
            //         deliveryWay: 1
            //       }
            //     ],
            //     bizType: 'need',
            //     bizId: requirementId
            //   },
            //   { settlementId: requirementId, isDrug }
            // );
            return;
          }
          this.$router.push({
            name: 'BindingDoctors',
            query: { requirementId, isDrug }
          });
        })
        .catch((err) => (this.popupVisible = false));
      this.load = false;
    },
    httpsImg(s) {
      return window.util.httpsReplace(s);
    },
    async _getData() {
      try {
        const { itemId, isDrug } = this.$route.query;
        this.itemId = itemId;
        this.isDrug = isDrug;
        const r = await this.$fetch.getItemDetail({
          itemId
        });
        if (!r) {
          this.isErrorPage = true;
          return;
        }
        this.message = r;
        this.cacheStock = {
          stockNum: r.stockNum || 0,
          stock: r.stock || 0
        };

        this.infoList = this.infoList.map((item) => {
          item.value = this.message[item.key];
          return item;
        });

        this.noDrugInfoList = this.noDrugInfoList.map((item) => {
          item.value = this.message[item.key];
          return item;
        });

        this.descList = this.descList.map((item) => {
          item.value = this.message[item.key];
          return item;
        });

        await this.getItemMun(itemId);
        this.isErrorPage = false;
      } catch (e) {
        this.isErrorPage = true;
      }
    },
    onChange(index) {
      this.current = index;
    },
    showPreview() {
      // eslint-disable-next-line
      ImagePreview({
        images: this.imageList,
        startPosition: this.current,
        closeable: true
      });
    },

    getTipList() {
      this.$fetch.getMallResourceStateList({ resourceCodeList: [ResourceCodeEnum.TipsList] }).then((res) => {
        const resource = (res && res[0]) || {};
        const { resourceContentList = [] } = resource;
        this.tipList = resourceContentList;
      });
    },
    addOssParams(h, w) {
      return `?x-oss-process=image/resize,m_fill${w ? ',w_' + w : ''}${h ? ',h_' + h : ''}`;
    },
    handleDiseaseClose() {
      this.diseasePopupVisible = false;
    },
    handleDiseaseCross() {
      this.submit(this.tempAmount);
    },
    handleDiseaseConfirm(params) {
      this.submit(this.tempAmount, params);
    }
  }
};
</script>
<style lang="scss" scoped>
.specification {
  position: relative;
  height: 100%;

  .fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 444;
    border-top: 1px solid rgba(0, 0, 0, 0.04);
    .error-tip {
      position: absolute;
      height: 40px;
      width: 100%;
      top: -40px;
      background: rgba(0, 0, 0, 0.65);
      color: #fff;
      font-size: 14px;
      text-align: center;
      line-height: 40px;
    }
  }

  .fix-content {
    background: #fff;
    height: 60px;
  }
  .left {
    font-size: 9px;
    color: #595959;
    img {
      width: 20px;
      margin-bottom: 7px;
    }
  }
  .right {
    min-width: 240px;
  }
  .submit_button {
    height: 40px;
    font-size: 16px;
    color: #1e8dff;
    &.button1 {
      width: 132px;
      color: #ffffff;
      margin-left: 10px;
    }
  }
  ::v-deep .van-button--warning {
    width: 116px;
    color: #fff;
    background-color: #ffaa00;
    border: 1px solid #ffaa00;
  }
  .bgf {
    background: #ffffff;
  }
  .box {
    flex: 1;
    background: #f7f8fa;
    height: 100%;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 0 !important;
      height: 0 !important;
    }
    // .img {
    //   ::v-deep .swiper-imgs {
    //     .swiper-slide {
    //       padding-top: 0;
    //     }
    //   }
    // }
    .medicalMessage {
      @extend .bgf;
      margin-top: 10px;
    }
    .medicalExtMessage {
      margin-top: 16px;
      @extend .bgf;
      padding: 16px;
      padding-top: 0;
      padding-bottom: 0;
      &Item {
        border-bottom: 1px solid #e0e0e0;
        padding-bottom: 16px;
        padding-top: 16px;

        &Title {
          font-size: 16px;
          font-weight: 400;
          color: #323234;
        }
        &Content {
          margin-top: 12px;
          font-weight: 400;
          font-size: 16px;
          color: #707070;
        }
      }
    }
    .bottom {
      height: 70px;
      text-align: center;

      color: #999999;
      font-size: 12px;
      font-weight: 400;
    }
    .short-bottom {
      height: 16px;
    }
    .tabs {
      ::v-deep .van-tabs__wrap {
        .van-tab {
          color: #262626;
          font-size: 14px;
          span {
            display: inline-block;
            font-size: 14px;
            line-height: 18px;
          }
        }
        .van-tab--active {
          color: #1e8dff;
        }
        .van-tabs__line {
          width: 18px !important;
        }
        &::after {
          border-width: 0 0 1px 0;
        }
      }
    }
    .no-drug-table {
      background: #fff;
      margin-top: 10px;
      font-size: 14px;
      font-weight: 500;
      color: #262626;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-bottom: 1px solid #eee;
    }
    .tab-container {
      padding: 20px 16px;
      background: #fff;
      &.no-padding {
        padding: 0;
      }
      .img-intro {
        width: 100%;
        display: block;
      }
      .tip-box {
        margin: 0 -4px;
      }
      .explain {
        margin-top: 24px;
        li {
          margin-bottom: 24px;
          ._title {
            margin: 0 0 6px -8px;
            font-weight: 500;
            color: #262626;
            line-height: 21px;
            font-size: 14px;
          }
          .desc {
            font-size: 14px;
            font-weight: 400;
            color: #595959;
            line-height: 21px;
            word-break: break-word;
            white-space: pre-line;
          }
        }
      }
    }
    .panel {
      @extend .bgf;
      border-radius: 8px;
      margin: 12px;
      padding: 12px;
      word-break: break-all;
    }
    .separator {
      height: 1px;
      width: 100%;
      background: #eeeeee;
      transform: scaleY(0.5);
    }
    .img-fit-contain {
      ::v-deep .van-swipe {
        .swiper-slide .van-image {
          img.van-image__img {
            object-fit: contain !important;
          }
        }
      }
    }
    .main-info {
      @extend .panel;
      .price {
        display: block;
        font-size: 24px;
        font-weight: bold;
        color: #ff4e47;
        margin-bottom: 12px;
        &.isSellOut {
          color: #bfbfbf;
        }
        &::before {
          content: '￥';
          font-size: 16px;
        }
      }
      .tag-rx {
        width: 64px;
        background: #52c41a;
        border-radius: 2px;
        font-size: 10px;
        color: #ffffff;
        line-height: 14px;
        text-align: center;
        position: relative;
        bottom: 1px;
        display: inline-block;

        margin-right: 2px;
        height: 28px;
        line-height: 28px;
        font-size: 20px;
        transform: scale(0.5);
        transform-origin: 0% 0%;
      }
      .tag-otc {
        width: 64px;
        background: #2fbb9e;
        border-radius: 2px;
        color: #ffffff;
        text-align: center;
        display: inline-block;
        margin-right: 2px;
        height: 28px;
        line-height: 28px;
        font-size: 20px;
        transform: scale(0.5);
        transform-origin: 0% 0%;
      }
      .name {
        display: block;
        // align-items: center;
        font-size: 16px;
        font-weight: bold;
        color: #262626;
        // line-height: 24px;
        margin-bottom: 12.5px;
      }
      .labels {
        margin-top: 12px;
        display: block;
        width: 100%;
      }
    }
    .indication {
      @extend .panel;
      .title {
        font-size: 16px;
        font-weight: bold;
        color: #262626;
        line-height: 1;
        margin-bottom: 12px;
      }
      .text {
        font-size: 14px;
        color: #262626;
        line-height: 1.5;
      }
    }
    .data-table {
      @extend .panel;
      padding: 0 12px;
      .line {
        height: 52px;
        display: flex;
        align-items: center;
        .label {
          width: 80px;
          font-size: 14px;
          color: #8c8c8c;
        }
        .value {
          font-size: 14px;
          color: #262626;
        }
      }
    }
  }
}
.brand-publicity {
  padding: 0;
  margin: 12px 0 0;
  display: flex;
  justify-content: space-between;
  .icon-box {
    display: flex;
    font-size: 12px;
    font-weight: 400;
    color: #8c8c8c;
    line-height: 16px;
    .van-icon {
      margin-right: 2px;
    }
  }
}
</style>
